// imports
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

// local imports
import '@uswds/uswds/css/uswds.min.css';
import './index.css';
import App from './App/App.tsx';
import store from './store';

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
